import IconBg from "./bg.png";
import IconClose from "./close.svg?react";
import IconPhone from "./h5.svg?react";
import "./index.scss";
import IconRight from "./right.svg?react";
import IconSplit from "./split.svg?react";
import commonservice from "@apis/commonservice";
import { IconPc } from "@icons/index";
import { selectCurrentGroupChat } from "@store/configurations/selectQrcode";
import { Modal } from "antd";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { useSelector } from "react-redux";

interface DeviceModalProps {
  open: boolean;
  onOk: () => void;
  phoneInfo: { phone: string; prefix: string };
}

export default ({ open, onOk, phoneInfo }: DeviceModalProps) => {
  const groupChat = useSelector(selectCurrentGroupChat);
  const [devices, setDevices] = useState<any>([] as any);

  useEffect(() => {
    if (phoneInfo) {
      (async () => {
        const devices = await commonservice.queryDevices({
          phoneCountryCode: phoneInfo.prefix,
          phoneNumber: phoneInfo.phone,
        });
        setDevices(devices);
      })();
    }
  }, [phoneInfo]);

  return (
    <Modal open={open} className="PageHome-DeviceModal" onCancel={onOk} closeIcon={<IconClose></IconClose>}>
      <div className="content">
        <div className="header">
          <div className="bg" style={{ backgroundImage: `url(${IconBg})` }}></div>
          <div className="title">
            <Trans>Your account has already logged into 2 devices, reaching the upper limit of login devices.</Trans>
          </div>
          <div className={classNames("devices", devices.length <= 2 ? "center" : "")}>
            {devices.map((device: any) => {
              return (
                <div className="device" key={device.id}>
                  {device.type !== "mobile" && <IconPc className="icon"></IconPc>}
                  {device.type === "mobile" && <IconPhone className="icon"></IconPhone>}
                  <div className="name text-ellipsis1">{device.name}</div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="body">
          <div className="title">
            <Trans>How to solve this problem?</Trans>
          </div>
          <div className="option1">
            <div className="name">
              <Trans>Option 1</Trans>.<Trans>Unbind Device</Trans>
            </div>
            <div className="steps">
              <div className="step text-ellipsis2">
                <Trans>Go back to the device you have previously logged in</Trans>
              </div>
              <IconSplit className="icon-split"></IconSplit>
              <div className="step text-ellipsis2">
                <Trans>{'Go to "My Kalodata" -> "Device"'}</Trans>
              </div>
              <IconSplit className="icon-split"></IconSplit>
              <div className="step text-ellipsis2">
                <Trans>{"Select device and unbind"}</Trans>
              </div>
            </div>
          </div>
          <div className="option2">
            <div className="name">
              <Trans>Option 2</Trans>.<Trans>Contact customer service for help</Trans>
            </div>
            <div className="main">
              <div className="left">
                <Trans>If you still haven't solved the problem, please join the support group seeking for help</Trans>
              </div>
              <div className="right">
                <div className="qrcode" style={{ backgroundImage: `url(${groupChat?.imageURL})` }}></div>
                <div className="info">
                  <div className="name">
                    <Trans>{groupChat?.name}</Trans>
                  </div>
                  <div
                    className="join"
                    onClick={() => {
                      window.open(groupChat?.link, "_target");
                    }}
                  >
                    <Trans>Click to join</Trans>
                    <IconRight></IconRight>
                  </div>
                  <div
                    className="other"
                    onClick={() => {
                      window.open("/?scroll=footer", "_blank");
                    }}
                  >
                    <Trans>Other Groups</Trans>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
